import { render } from "./Of.vue?vue&type=template&id=4524f086"
import script from "./Of.vue?vue&type=script&lang=js"
export * from "./Of.vue?vue&type=script&lang=js"
script.render = render

export default script